"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var boxShadow = function (color) { return "box-shadow:  " + color + ";"; };
exports.default = (function (_a) {
    var hovered = _a.hovered, active = _a.active;
    return function (_a) {
        var theme = _a.theme;
        if (hovered) {
            return boxShadow(theme.palette.dropdownBoxShadow[1]);
        }
        if (active) {
            return boxShadow(theme.palette.dropdownBoxShadow[2]);
        }
        return boxShadow(theme.palette.dropdownBoxShadow[0]);
    };
});
